import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

import type { ContextMenuItem } from '@/types/editor'

// MenuComponent is recursive — Vue 3 <script setup> resolves the component
// by its filename automatically for recursive references.


export default /*@__PURE__*/_defineComponent({
  __name: 'MenuComponent',
  props: {
    items: { default: () => [] },
    submenu: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_MenuComponent = _resolveComponent("MenuComponent", true)!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    activator: "parent",
    submenu: __props.submenu
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: index,
              onClick: item.action
            }, _createSlots({
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024),
                (item.children)
                  ? (_openBlock(), _createBlock(_component_MenuComponent, {
                      key: 0,
                      items: item.children,
                      submenu: true
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (item.children)
                ? {
                    name: "append",
                    fn: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-menu-right",
                        size: "x-small"
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["submenu"]))
}
}

})